import { IInformationState } from '../interface/InformationState';

type WithInformationState = {
  InformationSlice: IInformationState;
};

export const InformationStateSelector = (
  state: WithInformationState,
): IInformationState => state.InformationSlice;
